// DataTable.js
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Table, Button, Divider, Spin, message, Modal, Form, Upload, Input, Select, Image, Space, Popconfirm, Tooltip } from 'antd';
import APIUtils from '../../api/APIUtils';
import WebLinks from '../../api/WebLinks';
import { UploadOutlined, PlayCircleOutlined,DeleteOutlined } from '@ant-design/icons';
import Cookies from 'js-cookie';
import constants from '../../constants/constants';
import { CommonContext } from '../../Context';
import { trackPageAccess } from '../../globalFunctions/GlobalFunctions';

const TikTokConfigure = () => {
    const commonContext=useContext(CommonContext);
    const buyerId = commonContext.common.buyerId;
    const [Loading,setLoading]=useState(false);
    const [NewModalOpen,setNewModalOpen]=useState(false);
    const [updateRecord,setUpdateRecord]=useState(false);
    const [updateImage,setUpdateImage]=useState(null);
    const [data,setData]=useState([]);
    const [occupations,setOccupations]=useState([]);
    const [form] = Form.useForm();
    const [visibleVideo, setVisibleVideo] = useState(false);
    const [urlTypeValue, setUrlTypeValue] = useState('CareersSiteJobURL');
    const [pagination, setPagination] = useState({
      current: 1,
      pageSize: constants.pageSize,
      total: 0,
    });
    const [videoUrl, setVideoUrl] = useState('');
    const [jobURl,setJobUrl]=useState('');
    const [jobURlParam,setJobUrlParam]=useState('');
    const [sorter, setSorter] = useState({
      field: 'Occupation',
      order: 'ascend',
    });
    const [finalURL,setFinalURL]=useState('');
    const isSelfService= sessionStorage.getItem('isSelfService');
    const isSelfServiceUser = isSelfService === true || isSelfService === "true";
    const [careerSiteDomain,setCareerSiteDomain]=useState(null);
    const [siteUrlLinks,setSiteUrlLinks]=useState([])
    
    const columns = [
      {
        title: 'ID',
        dataIndex: 'id',
        key: 'id',
        sorter: true
      },
      {
        title: 'Occupation',
        dataIndex: 'occupation',
        key: 'occupation',
        sorter: true
      },
      {
        title: 'Promo Image',
        dataIndex: 'socialPostImageURL',
        key: 'promoimage',
          render: (text) =>text? <Image src={text} alt="Promo" className='!w-36' />:null,
        align:'center'
      },
      {
        title: 'Promo Video',
        dataIndex: 'socialPostVideoURL',
        key: 'socialPostVideoURL',
        render: (text) =>text?<Tooltip title="Play Video"><Button type='link' onClick={() => handlePlay(text)} icon={<PlayCircleOutlined className='!text-3xl text-teal-500' />}/></Tooltip>:null,
        align:'center'
      },
      {
        title: 'Promo Text',
        dataIndex: 'socialPostText',
        key: 'promotext',
      },
      {
        title: 'Actions',
        key: 'actions',
        align: 'center',
        render: (text, record) => (
          <Space>
            <Button type="primary" size='small' onClick={() => handleUpdate(record.id)}>
              Update
            </Button>
            <Popconfirm
              title="Are you sure to delete this record?"
              onConfirm={ () => handleDelete(record.id)}
              okText="Yes"
              cancelText="No"
            >
                <Button type="primary" danger size='small'>
                Delete
              </Button>
            </Popconfirm>
          </Space>
        ),
      },
    ];
    const urlTypeOptions = isSelfService === true || isSelfService === "true"
      ? careerSiteDomain == null
        ? [
            {
              key: 1,
              value: 'ApplyGatewayJobURL',
              label: "Apply Gateway Job URL",
            },
          ]
        : [
          {
            key: 1,
            value: 'HICareersSiteJobURL',
            label: "HI Careers Site",
          },
          {
            key: 2,
            value: 'ApplyGatewayJobURL',
            label: "Apply Gateway Job URL",
          },
        ]
      : [
          {
            key: 1,
            value: 'CareersSiteJobURL',
            label: "Careers Site Job URL",
          },
          {
            key: 2,
            value: 'ApplyGatewayJobURL',
            label: "Apply Gateway Job URL",
          },
          {
            key: 3,
            value: 'LandingPageURL',
            label: "Landing Page URL",
          },
          ...(careerSiteDomain == null ? [] : [{
            key: 4,
            value: 'HICareersSiteJobURL',
            label: "HI Careers Site",
          }]),
        ];
    const handleUpdate = (id) => {
      loadOccupations();
      const editRecord = data.find((row)=> row.id===id);
      setUpdateRecord(editRecord);
      setNewModalOpen(true);
      setUpdateImage(editRecord.socialPostImageURL);
      setImageurl(editRecord.socialPostImageURL);
      setUrlTypeValue(editRecord.socialPostURLType);
      setJobUrlParam(editRecord?.socialPostURLParams||'')
      getJobURL(editRecord.occupationId,editRecord?.jobId);
      redirectToJobURL(editRecord?.socialPostURLParamsReplace,editRecord?.socialPostURLParams,"t");
      form.setFieldsValue({
        promoText:editRecord.socialPostText,
        occupation: editRecord.occupationId,
        urlTypes: editRecord.socialPostURLType,
        urltrackingCode: editRecord?.socialPostURLParams||"",
        urltrackingCodeReplace: editRecord?.socialPostURLParamsReplace||"",
        landingPageUrl: editRecord?.socialPostLandingPage||[]
      })
    };
    const handleDelete = async(id) => {
          setLoading(true);
          const response = await APIUtils.apiCall('DELETE',WebLinks.DeleteTikTokConfig+id,null,true,false);
          if(!response.isCatch && response.resultObj.statusCode==="2000"){
             getData(pagination.current);
             getOccupations();
             message.success(response?.resultObj?.message || "Deleted record successfully");
          }else{
              message.error(response?.resultObj?.message || constants.ERROR_MESSAGE);
          }
          setLoading(false);
    };
    const getData = async()=>{
        setLoading(true);
        let desc = sorter.order === 'descend' ? "true" : "false";
        const response = await APIUtils.apiCall('GET',WebLinks.GetTikTokConfigure+"buyerId="+buyerId+"&limit="+pagination.pageSize+"&pageNo="+pagination.current+"&orderBy="+sorter?.field +"&sortDesc="+desc,null,true,false);
        if(!response.isCatch && response.resultObj.statusCode==="2000"){
            //Added unique key to fix all inner tables opening together
            response.resultObj.data?.map((item,index)=>{
                item.key=index;
            });
            setData(response?.resultObj?.data);
            setPagination((prev) => ({
              ...prev,
              total: response?.resultObj?.getCount || 0,
            }));
        }else{
            setData([]);
            //message.error(response?.resultObj?.message);
        }
        setLoading(false);
    };

    const getSiteUrls = async() =>{
      setLoading(true);
      const response = await APIUtils.apiCall('GET',WebLinks.GetSiteUrlLinks+buyerId,null,true,false);
      if(!response.isCatch && response.resultObj.statusCode==="2000"){
          setSiteUrlLinks(response?.resultObj?.data);
      }else{
          setSiteUrlLinks([]);
          message.error(response?.resultObj?.message || constants.ERROR_MESSAGE);
      }
      setLoading(false);
    };    
    //Get Job URl
    const getJobURL = async(occupationId,jobId)=>{
      let occupationIdValue=occupationId?occupationId:"";
      let jobIdValue=jobId?jobId:"";
        const response = await APIUtils.apiCall('GET',WebLinks.GetSocialConfigureJobURL+"buyerId="+buyerId+"&occupationId="+occupationIdValue+"&jobId="+jobIdValue);
        if(!response.isCatch && response.resultObj.statusCode==="2000"){
          if(response?.resultObj?.data){
            //const urlJob = new URL(response?.resultObj?.data);
            //const extractedURL = `${urlJob?.protocol}//${urlJob?.host}`;
            setJobUrl(response?.resultObj?.data);
            setCareerSiteDomain(response?.resultObj?.careerSiteDomain||null);
          }else{
            setJobUrl('');
            setCareerSiteDomain(null);
          }
        }else{
            setJobUrl('');
            setCareerSiteDomain(null);
        }
    };
    const getOccupations = async() =>{
        setLoading(true);
        const response = await APIUtils.apiCall('GET',WebLinks.GetSocialOccupations+buyerId+"&limit=25&pageNo=1&orderBy=OccupationId&sortDesc=false",null,true,false);
        if(!response.isCatch && response.resultObj.statusCode==="2000"){
            //Added unique key to fix all inner tables opening together
            response.resultObj.data?.map((item,index)=>{
                item.key=index;
                item.value = item.occupationId;
                item.label = item.occupation;
                item.disabled = !!(response.resultObj.defaultExist && item.occupationId===0);
            });
            setOccupations(response?.resultObj?.data);
        }else{
            setData([]);
            message.error(response?.resultObj?.message || constants.ERROR_MESSAGE);
        }
        setLoading(false);
    };
    const handleCancel = () => {
        form.resetFields();
        setImageurl('')
        setFinalURL('');
        setNewModalOpen(false);
        if(updateRecord){
          setUpdateRecord(null);
        }
        setUrlTypeValue('CareersSiteJobURL');
    };
    const onFinish = async (values) => {
      if(values?.promoImage && values?.promoImage[0]?.originFileObj&&imageurl===''){
        message.error("Please upload valid image.")
      }else{
        if(values?.promoVideo && values?.promoVideo[0]?.originFileObj){
          if(values?.promoVideo[0]?.originFileObj.type!=="video/mp4"){
            message.error('You can only upload MP4 files!');
          }else{
            saveConfig(values);
          }
        }else{
          saveConfig(values);
        }
      }
    };
    const saveConfig=async (values)=>{
      const formData = new FormData();
      if(values?.promoImage && values?.promoImage[0]?.originFileObj){
        formData.append('Image',  values.promoImage[0].originFileObj);
      }else{
        formData.append('Image',null);
      }
      if(values?.promoVideo && values?.promoVideo[0]?.originFileObj){
        formData.append('Video',  values.promoVideo[0].originFileObj);
      }
      if(updateRecord){
        formData.append('SocialConfigure.Id', updateRecord.id);
      }
      formData.append('SocialConfigure.BuyerId', buyerId);
      formData.append('SocialConfigure.OccupationId', values.occupation);
      formData.append('SocialConfigure.SocialPostText', values.promoText);
      const socialPostURLType = isSelfServiceUser
        ? careerSiteDomain == null ? "ApplyGatewayJobURL" : "HICareersSiteJobURL"
        : values.urlTypes;
      formData.append('SocialConfigure.SocialPostURLType', socialPostURLType);      if(urlTypeValue==="CareersSiteJobURL" && values?.urltrackingCode){
        formData.append('SocialConfigure.SocialPostURLParams', values.urltrackingCode);
      }
      if(urlTypeValue==="CareersSiteJobURL" && values?.urltrackingCodeReplace){
        formData.append('SocialConfigure.socialPostURLParamsReplace', values.urltrackingCodeReplace);
      }
      if(urlTypeValue==="LandingPageURL" && values?.landingPageUrl){
        formData.append('SocialConfigure.SocialPostLandingPage', values.landingPageUrl);
      }
      try {
        let url= updateRecord?WebLinks.UpdateTikTokConfig:WebLinks.AddTikTokConfig;
          const response = await fetch(url, {
            method: updateRecord?'PUT':'POST',
            headers: {
              Authorization: "Bearer "+Cookies.get(constants.COOKIE_TOKEN)
            },
            body: formData,
          });
          const responseData = await response.json();
          if (response.ok) {
            message.success(responseData?.message || "Inserted record successfully");
            handleCancel();
            getData(pagination.current);
          } else {
              message.error(responseData?.message || constants.ERROR_MESSAGE);
          }
        } catch (error) {
          console.error('Error uploading image:', error);
      }  
    }
    const loadOccupations =async()=>{
      if (!occupations.length > 0) {
        await getOccupations();
      }
    };

    const renderUpdateImageFields = () =>{
      return(
        <div className="flex flex-wrap mb-4">
          {/* Current Image */}
          <div className="w-1/2 pr-4">
              <Image src={updateImage} className="max-w-full" />
          </div>
        {/* Upload Button */}
          <div className="w-1/2 pl-4">
            <Form.Item
              name="promoImage"
              label=" "
              valuePropName="fileList"
              getValueFromEvent={(e) => e.fileList} 
            >
              <Upload
              name="logo"
              listType="picture"
              accept=".png,.jpg,.jpeg"
              beforeUpload={() => false}
              onChange={(e)=>onUploadChange(e)}
              maxCount={1}
              >
                <Button icon={<UploadOutlined />}>Click to update Promo Image</Button><span className='ml-2'><i>(Requirements: JPG or PNG. Min Width 600px  / Ratio 1:1 or 4:5)</i></span>
              </Upload><Tooltip title={"Remove Image"}><Button icon={<DeleteOutlined/>} danger onClick={()=>{setImageurl('');setUpdateImage(null)}}/></Tooltip>
            </Form.Item>
          </div>
      </div>
      );
    };
    const renderUpdateVideoFields = () =>{
      return(
        <div className="flex flex-wrap mb-4">
          {/* Current Video */}
          <div className="w-1/2 pr-4">
            <video controls className="max-w-full" >
              <source src={updateRecord?.socialPostVideoURL}/>
            </video>
          </div>
        {/* Upload Button */}
          <div className="w-1/2 pl-4">
            <Form.Item
              name="promoVideo"
              label="Promo Video"
              valuePropName="fileList"
              getValueFromEvent={(e) => e.fileList} 
            >
              <Upload
              name="videoPromo"
              listType="picture"
              accept="video/mp4"
              beforeUpload={()=>false}
              maxCount={1}
              >
                <Button icon={<UploadOutlined />}>Click to add Promo Video</Button><span className='ml-2'><i>(MP4 file only)</i></span>
              </Upload>                    
            </Form.Item> 
          </div>
      </div>
      );
    };
    const handleTableChange = (pagination, filters, sorter) => {
      setPagination(pagination);
      if(sorter?.field!==undefined){
        setSorter(sorter);
      }
    };
    const handlePlay = (url) => {
      setVideoUrl(url);
      setVisibleVideo(true);
    };
  
    const handleCancelVideo = () => {
      setVideoUrl('');
      setVisibleVideo(false);
    }
    const [imageurl,setImageurl]=useState('');
    const onUploadChange=(e)=>{
      const imageUrl = URL.createObjectURL(e.file); // Get the object URL
      setImageurl(imageUrl);
   
    }
    const handleImageLoad = (e) => {
      const { naturalWidth, naturalHeight } = e.target; // Get image dimensions
      const aspectRatio = naturalWidth / naturalHeight;
       if ( (aspectRatio !== 1 && aspectRatio !== 4 / 5)) {
          message.error('Image requirements not matching.');
          setImageurl('');
      }
    };
    const redirectToJobURL = (codeReplace, trackingCode, loadCall="f", baseUrl) => {
      const normalizeTrackingCode = (trackingCode) =>
        trackingCode?.trim()?.replace(/^[?&]+/, '') || '';
      const replaceTrackingCode = normalizeTrackingCode(codeReplace?codeReplace: form.getFieldValue("urltrackingCodeReplace"));
      const newTrackingCode = normalizeTrackingCode(trackingCode?trackingCode: form.getFieldValue("urltrackingCode"));
      let finalJobUrl = baseUrl || jobURl || "";

      if (!finalJobUrl) {
        setFinalURL('');
        if(loadCall!=="t"){
          message.error("No Career site URL found.");
        }
        return;
      }

      if (newTrackingCode) {
        if (replaceTrackingCode && replaceTrackingCode.length > 0) {
          const escapedTrackingCode = replaceTrackingCode.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
          const exactTrackingCodePattern = new RegExp(`([?&])${escapedTrackingCode}(?=&|$)`);
          const trackingParameterName = replaceTrackingCode.split('=')[0];
          const escapedParameterName = trackingParameterName.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
          const trackingParameterPattern = new RegExp(`([?&])${escapedParameterName}=[^&]*`);
          const replacement = (match, separator) => `${separator}${newTrackingCode}`;

          finalJobUrl = exactTrackingCodePattern.test(finalJobUrl)
            ? finalJobUrl.replace(exactTrackingCodePattern, replacement)
            : finalJobUrl.replace(trackingParameterPattern, replacement);
        } else {
          finalJobUrl = `${finalJobUrl}${finalJobUrl.includes("?") ? "&" : "?"}${newTrackingCode}`;
        }

        setJobUrlParam(newTrackingCode);
      } else if (replaceTrackingCode) {
        const parameterName = replaceTrackingCode.split('=')[0];
        const escapedParameterName = parameterName.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        finalJobUrl = finalJobUrl.replace(new RegExp(`[?&]${escapedParameterName}=[^&]*`), '');
        finalJobUrl = finalJobUrl.replace(/\?&/g, '?').replace(/&&+/g, '&').replace(/[?&]$/, '');
        setJobUrlParam('');
      }
      setFinalURL(finalJobUrl);
      if(loadCall!=="t"){
      window.open(finalJobUrl, '_blank');
      }
    }
    const redirectToLandingURL=()=>{
      let getLandingURL= form.getFieldValue("landingPageUrl");
        if(getLandingURL){
          window.open(getLandingURL, '_blank');
        }else{
          message.error("No Landing page URL found.")
        }
    }
    useEffect(()=>{
        getData();
        getJobURL();
        // getSiteUrls();
    },[pagination.current, pagination.pageSize, sorter.field, sorter.order]);
  useEffect(() => {
    trackPageAccess(buyerId,window.location.href)
  }, []);  
    return(
    <div>
        <Spin spinning={Loading}>
            <div className='flex flex-wrap justify-between items-center'>
                <div className='uppercase font-bold text-xl'>Tik Tok Configuration</div>
                <div>
                    <Button type="primary" style={{ marginRight: '10px' }} onClick={async () => {
                        loadOccupations();
                        setNewModalOpen(true);
                        form.setFieldsValue({
                          urlTypes: isSelfService === true || isSelfService === "true"
                            ? careerSiteDomain != null
                              ? "HICareersSiteJobURL"
                              : "ApplyGatewayJobURL"
                            : "CareersSiteJobURL"
                    })
                    }}>
                        Add New
                    </Button>
                    {/* Add your logic to handle the "Add New" button */}
                </div>
            </div>
            <Divider className='my-3' />
            <Table scroll={{ x: '1000' }} sortDirections={['descend', 'ascend', 'descend']} columns={columns} dataSource={data} pagination={pagination} onChange={handleTableChange}/>
            {/* AddNew */}
            <Modal
              title={updateRecord?"Edit Configuration":"Add New Configuration"}
              open={NewModalOpen}
              onCancel={handleCancel}
              okText={<span className="capitalize">Save</span>}
              onOk={() => form.submit()}
              style={{ top: 20 }}
              width={800}
            >
                <Form form={form} name="form_in_modal" layout="vertical" onFinish={onFinish}>
                    <Form.Item
                        name="occupation"
                        label="Occupation"
                    >
                        <Select placeholder="Select Occupation" options={occupations} onChange={(e)=>getJobURL(e)}/>
                    </Form.Item>
                    {updateRecord&&updateRecord.socialPostImageURL&&updateImage!==null?renderUpdateImageFields():(
                      <Form.Item
                        name="promoImage"
                        label="Promo Image"
                        valuePropName="fileList"
                        getValueFromEvent={(e) => e.fileList} 
                      >
                        <Upload
                        name="logo"
                        listType="picture"
                        accept=".png,.jpg,.jpeg"
                        beforeUpload={()=>false}
                        onChange={(e)=>onUploadChange(e)}
                        maxCount={1}
                        >
                          <Button icon={<UploadOutlined />}>Upload New Image</Button><span className='ml-2'><i>(Requirements: JPG or PNG. Min Width 600px  / Ratio 1:1 or 4:5)</i></span>
                        </Upload>                    
                      </Form.Item>
                    )}
                    <Form.Item hidden>
                      <Image src={imageurl}  onLoad={handleImageLoad}/>
                    </Form.Item>
                    {updateRecord&&updateRecord.socialPostVideoURL?renderUpdateVideoFields():(
                    <Form.Item
                        name="promoVideo"
                        label="Promo Video"
                        valuePropName="fileList"
                        getValueFromEvent={(e) => e.fileList} 
                        rules={[
                          {
                          required: true,
                          message: "Required field",
                          },
                      ]}
                      >
                        <Upload
                        name="videoPromo"
                        listType="picture"
                        accept="video/mp4"
                        beforeUpload={()=>false}
                        maxCount={1}
                        >
                          <Button icon={<UploadOutlined />}>Click to add Promo Video</Button><span className='ml-2'><i>(MP4 file only)</i></span>
                        </Upload>                    
                      </Form.Item> )}                   
                    <Form.Item
                        name="promoText"
                        label="Promo Text"
                        rules={[
                            {
                            required: true,
                            message: "Required field",
                            },
                        ]}
                    >
                        <Input.TextArea rows={5}/>
                    </Form.Item>
                    {!isSelfServiceUser && <Form.Item
                        name="urlTypes"
                        label="Send clicks to URL type"
                        // rules={[
                        //     {
                        //     required: true,
                        //     message: "Required field",
                        //     },
                        // ]}
                    >
                        <Select
                          onChange={(value) => {
                            setUrlTypeValue(value);
                            setFinalURL('');
                            form.setFieldsValue({ sendClickstoURL: undefined });
                          }}
                          options={urlTypeOptions}
                        />
                    </Form.Item>}
                    {/* {(urlTypeValue === "LandingPageURL" || urlTypeValue === "CareersSiteJobURL") && (
                      <Form.Item
                        name="sendClickstoURL"
                        label="Send Clicks to URL"
                      >
                        <Select
                          placeholder="Select URL"
                          onChange={(value) => redirectToJobURL(undefined, undefined, "t", value || jobURl)}
                          options={siteUrlLinks
                            .filter((siteUrl) =>
                              siteUrl.resultType ===
                              (urlTypeValue === "LandingPageURL" ? "Landing Page" : "Careers Site")
                            )
                            .map((siteUrl) => ({
                              value: siteUrl.value,
                              label: siteUrl.displayText,
                            }))}
                        />
                      </Form.Item>
                    )} */}
                    {!isSelfServiceUser && urlTypeValue === "CareersSiteJobURL" 
                    // || urlTypeValue === "LandingPageURL"
                  ?
                    <>
                    <Form.Item
                        name="urlLabel"
                        label="Example of Your URL"
                      >
                    <label>{finalURL || jobURl || ''}</label>                    
                    </Form.Item>
                    <Space>
                      {/* {updateRecord? */}
                      <Form.Item
                        name="urltrackingCodeReplace"
                        label="Replace this tracking Code"
                      >
                        <Input />
                    </Form.Item>
                    {/* :null} */}
                      <Form.Item
                        name="urltrackingCode"
                        label="Add URL Tracking Codes"
                      >
                        <Input />
                    </Form.Item>
                    <span><i>(Optional)</i><Button type='link' className='pr-1' onClick={()=>redirectToJobURL()}>Click Here</Button>to test</span>
                    </Space>
                    </>
                    : null}
                    {urlTypeValue === "LandingPageURL" && (
                    <div>
                      <Form.Item
                      className='mb-0'
                      name="landingPageUrl"
                      label="Landing Page - Enter custom URL"
                      rules={[
                          {
                          required: true,
                          message: "Required field",
                          },
                          {
                            type: 'url',
                            message: 'Please enter a valid URL (e.g., https://example.com)',
                          }
                      ]}
                      >
                          <Input/>
                      </Form.Item>
                      <span ><i>(Please enter full URL including https://)</i><Button type='link' className='pr-1' onClick={()=>redirectToLandingURL()}>Click Here</Button>to test</span>
                    </div>
                    )}
                </Form>
            </Modal>
            <Modal
              title="Promo Video"
              open={visibleVideo}
              onCancel={handleCancelVideo}
              footer={null}
              width={800}
            >
              <video
                src={videoUrl}
                controls
                style={{ width: '100%' }}
                autoPlay
              />
            </Modal>
        </Spin>
  </div>
    );
};

export default TikTokConfigure;
